import React, { Component } from 'react';
import SubNav from '../SubNav/SubNav';

class About extends Component
{
    render()
    {
        return (
            <div>
                <SubNav/>
                About
            </div>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/About/About.js